module.exports = __webpack_public_path__ + "static/media/registp01_ja.07763ed0.png";